<template>
	<div class="toaster-container">
		<transition-group name="toaster" tag="div">
			<ToasterItem
				v-for="item in items"
				:key="item.id"
				:type="item.type"
				:title="item.title"
				:content="item.content"
				:loading="item.loading"
				:timeout="item.timeout"
				:id="item.id"
				class="toaster-item"
				@clear="clear($event)">
			</ToasterItem>
			<v-btn
				small flat
				key="delete_all_btn"
				color="primary"
				@click="items = {}"
				v-if="Object.keys(items).length > 1"
				class="text-none toaster-item">
				<v-icon class="mr-2">close</v-icon>
				Tout supprimer
			</v-btn>
		</transition-group>
	</div>
</template>

<script>
import ToasterItem from '@/App_toaster_item.vue'
export default {
	name: 'Toaster',
	components: { ToasterItem },
	data () {
		return {
			items: {}
		}
	},
	methods: {
		clear (id) {
			if (this.items[id].cb) {
				this.items[id].cb()
			}
			this.$delete(this.items, id)
		}
	},
	mounted () {
		this.$Bus.$on('toaster', (payload) => {
			// this.$Toaster(toast)
			// TOAST PROPS: type - title - content - loading - timeout - id - remove
			if (payload.remove && payload.id) {
				this.clear(payload.id)
			} else {
				this.$set(this.items, payload.id, payload)
			}
		})
	}
}
</script>

<style lang="stylus" scoped>
.toaster-container
	position: fixed
	z-index: 9999
	bottom: 0
	width: 100%
	max-height: 100vh
	height: calc(100vh - 48px)
	align-content: end
	overflow-y: auto
	pointer-events: none
::-webkit-scrollbar
	width: 0

.v-btn
	pointer-events: auto
	width: 450px
	margin: 0 0 8px 12px

.toaster-item
	transition: all .5s

.toaster-enter
.toaster-leave-to
	opacity: 0
	transform: translateX(-100%)

.toaster-leave-active
	position: absolute
</style>



// WEBPACK FOOTER //
// src/App_toaster.vue